module.exports = __webpack_public_path__ + "img/chiromancy.fb4c7ba1.png";